import { render, staticRenderFns } from "./arrow-forward.vue?vue&type=template&id=56f03b25"
import script from "./arrow-forward.vue?vue&type=script&lang=js"
export * from "./arrow-forward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports